// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"87":"ec1fa560","153":"1ada3eb6","225":"c6b21483","399":"736e172c","401":"918251bf","440":"de064c76","442":"7206b9c8","787":"7e0b2aad","895":"0ddac508"}[chunkId] + ".chunk.js";
};